import React from 'react'

function Switch({value,chngValue}){
    let cls='rc-switch'
    if(parseInt(value)===1) cls='rc-switch-checked rc-switch'

    return (
        <button type="button" role="switch" aria-checked="false" className={cls} onClick={(e)=>chngValue(value)} onKeyUp={(e)=>{if(e.key === 'ArrowRight') chngValue(0); else if(e.key === 'ArrowLeft') chngValue(1)}}>

        </button>
    )

}

export default Switch